


export const GITLAB_URL = 'https://git.unistra.fr';
export const GITLAB_PAGES_URL = 'https://{namespace}.pages.unistra.fr/{name}';
export const pagesUrl = ({name, namespace}) => {
    return GITLAB_PAGES_URL.replace('{namespace}', namespace.name).replace('{name}', name);
};

